import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import Label from "@/Components/Label";
import LoadingButton from "@/Components/LoadingButton";
import { Inertia } from "@inertiajs/inertia";
import PageHeading from "@/Components/PageHeading";
import React from "react";
import TextInput from "@/Components/TextInput";
import SelectInput from "@/Components/SelectInput";

const Create = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Users", route: route("settings.users") },
        { name: "Create", route: null },
    ];

    const { data, setData, post, errors, clearErrors, transform, processing } =
        useForm({
            name: "",
            email: "",
            password: "",
            password_confirmation: "",
            role: "",
        });

    const { roles } = usePage().props;

    transform((data) => {
        return {
            ...data,
            role: data.role.id,
        };
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(route("settings.users.store"));
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("settings.users"));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Create Group"} breadcrumb={breadcrumb} />
            <div className="mt8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label name={"name"} label={"Name"} />
                                <TextInput
                                    id={"name"}
                                    name={"name"}
                                    onChange={(e) =>
                                        setData("name", e.target.value)
                                    }
                                    errors={errors.name}
                                    value={data.name}
                                />
                            </div>
                            <div>
                                <Label name={"email"} label={"Email"} />
                                <TextInput
                                    type={"email"}
                                    id={"email"}
                                    name={"email"}
                                    onChange={(e) =>
                                        setData("email", e.target.value)
                                    }
                                    errors={errors.email}
                                    value={data.email}
                                />
                            </div>
                            <div>
                                <Label name={"password"} label={"Password"} />
                                <TextInput
                                    type={"password"}
                                    id={"password"}
                                    name={"password"}
                                    onChange={(e) =>
                                        setData("password", e.target.value)
                                    }
                                    errors={errors.password}
                                    value={data.password}
                                />
                            </div>
                            <div>
                                <Label
                                    name={"password_confirmation"}
                                    label={"Confirm Password"}
                                />
                                <TextInput
                                    type={"password"}
                                    id={"password_confirmation"}
                                    name={"password_confirmation"}
                                    onChange={(e) =>
                                        setData(
                                            "password_confirmation",
                                            e.target.value
                                        )
                                    }
                                />
                            </div>
                            <div>
                                <SelectInput
                                    name={"role"}
                                    label={"Select Role"}
                                    selected={data.role}
                                    setSelected={(e) => setData("role", e)}
                                    items={roles}
                                    errors={errors.role}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className="btn-secondary"
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Save
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

Create.layout = (page) => (
    <Authenticated title={"Groups"}>{page}</Authenticated>
);

export default Create;
